/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Cool_Crane_ActInputs */

const en_bold_cool_crane_act = /** @type {(inputs: Bold_Cool_Crane_ActInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const de_bold_cool_crane_act = /** @type {(inputs: Bold_Cool_Crane_ActInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktionen`)
};

/**
* | output |
* | --- |
* | "Actions" |
*
* @param {Bold_Cool_Crane_ActInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_cool_crane_act = /** @type {((inputs?: Bold_Cool_Crane_ActInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Cool_Crane_ActInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_cool_crane_act(inputs)
	return de_bold_cool_crane_act(inputs)
});